import { IsInViewportQueue } from 'queue'
import React, { useEffect } from 'react'
import { useInView } from 'react-intersection-observer'

const IsInView: React.FC<{ param: string; className?: string; children: React.ReactNode }> = ({ param, className, children }) => {
  const { ref, inView } = useInView()

  useEffect(() => {
    IsInViewportQueue.emit({ element: param, intersecting: inView })
  }, [inView, param])

  return (
    <div ref={ref} className={className}>
      {children}
    </div>
  )
}

export default IsInView
